import React from 'react';
import { Badge } from '../ui/badge';
import { Clock, ShieldCheck } from '@phosphor-icons/react';

export const TierCard = ({ tier, tierKey, isSelected, onSelect, isEditing, onTierChange }) => {
  const tierColors = {
    economy: { bg: 'bg-neutral-100 dark:bg-neutral-800', border: 'border-neutral-400', accent: 'text-neutral-600' },
    standard: { bg: 'bg-[#2B4C6F]/10 dark:bg-[#2B4C6F]/20', border: 'border-[#2B4C6F]', accent: 'text-[#2B4C6F]' },
    premium: { bg: 'bg-amber-50 dark:bg-amber-900/20', border: 'border-amber-500', accent: 'text-amber-600' }
  };
  
  const colors = tierColors[tierKey];
  
  const handlePriceChange = (value) => {
    if (onTierChange) {
      onTierChange(tierKey, { ...tier, total: parseFloat(value) || 0 });
    }
  };
  
  const handleFieldChange = (field, value) => {
    if (onTierChange) {
      onTierChange(tierKey, { ...tier, [field]: value });
    }
  };
  
  return (
    <div
      onClick={() => !isEditing && onSelect(tierKey)}
      className={`w-full p-4 border-2 ${isSelected ? colors.border + ' ' + colors.bg : 'border-neutral-300 dark:border-neutral-700'} 
        transition-all text-left ${isSelected ? 'shadow-[4px_4px_0px_0px_#000] dark:shadow-[4px_4px_0px_0px_#2B4C6F]' : ''} 
        ${!isEditing ? 'cursor-pointer hover:border-neutral-400' : ''}`}
      data-testid={`tier-${tierKey}`}
    >
      <div className="flex items-center justify-between mb-2">
        <span className={`uppercase tracking-widest text-xs font-bold ${colors.accent}`}>
          {tier.name}
        </span>
        {tierKey === 'standard' && (
          <Badge className="bg-[#2B4C6F] text-white border-0 text-[10px]">RECOMMENDED</Badge>
        )}
        {tierKey === 'premium' && (
          <Badge className="bg-amber-500 text-white border-0 text-[10px]">BEST VALUE</Badge>
        )}
      </div>
      
      {isEditing ? (
        <div className="space-y-2">
          <div>
            <label className="text-xs text-neutral-500 uppercase">Price</label>
            <div className="flex items-center">
              <span className="text-lg font-bold mr-1">$</span>
              <input
                type="number"
                value={tier.total || 0}
                onChange={(e) => handlePriceChange(e.target.value)}
                className="w-full text-xl font-black text-neutral-900 dark:text-white font-mono bg-transparent border-b-2 border-dashed border-neutral-400 focus:border-[#2B4C6F] outline-none"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
          <div>
            <label className="text-xs text-neutral-500 uppercase">Timeline (days)</label>
            <input
              type="number"
              value={tier.timeline_days || 0}
              onChange={(e) => handleFieldChange('timeline_days', parseInt(e.target.value) || 0)}
              className="w-full text-sm font-mono bg-transparent border-b border-dashed border-neutral-300 focus:border-[#2B4C6F] outline-none"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      ) : (
        <>
          <p className="text-2xl font-black text-neutral-900 dark:text-white font-mono mb-2">
            ${tier.total?.toLocaleString() || 0}
          </p>
          <p className="text-xs text-neutral-600 dark:text-neutral-400 mb-2">
            {tier.materials_quality}
          </p>
          <p className="text-sm text-neutral-700 dark:text-neutral-300">
            {tier.description}
          </p>
          <div className="flex items-center gap-2 mt-3 text-xs text-neutral-500">
            <Clock size={12} />
            <span>{tier.timeline_days} days</span>
            <span className="mx-1">•</span>
            <ShieldCheck size={12} />
            <span>{tier.warranty}</span>
          </div>
        </>
      )}
    </div>
  );
};
